import request from '@/utils/request'

export function statistics(currentPage,pageSize,data) {
    // return request.get('http:9800//serviceCenter/test')
    return request({
        url: `api/serviceCenter/material/statistics?size=${pageSize}&current=${currentPage}`,
        method: 'post',
        data,
    })
}
